/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CancelAction from './CancelAction/index'
import CloseAction from './CloseAction/index'
import Fields from './Fields/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import RegisterAction from './RegisterAction/index'
import SearchForPhone from './SearchForPhone/index'
import Title from './Title/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Phone/NewPhone/Content"
  
}) {
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
 width={400}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<Fields
  viewPath={`${viewPath}/Fields`}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 justifyitems="spaceBetween"
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Horizontal1}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<RegisterAction
  viewPath={`${viewPath}/RegisterAction`}
/>
</div>
</div>
)}
</ModalFullScreen>
<SearchForPhone
  viewPath={`${viewPath}/SearchForPhone`}
/>
{children}
</React.Fragment>)
}